import React from 'react';
import About from '../components/About';
import WhyChoose from '../components/WhyChoose';

function AboutPage() {
  return (
    <div style={{ paddingTop: '100px' }}>
      <About />
      
      {/* Additional About Content */}
      <section style={{ padding: '5rem 0', background: '#fff' }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">Our Story</h2>
          </div>
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#555', marginBottom: '1.5rem' }}>
                BARQ ALWUSOOL BUSES RENTAL LLC was founded with a vision to provide 
                exceptional passenger transport services across the UAE. Over the years, 
                we have grown to become a trusted partner for businesses, schools, and 
                tourism operators throughout all seven Emirates.
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#555', marginBottom: '1.5rem' }}>
                Our commitment to safety, reliability, and customer satisfaction has made 
                us the preferred choice for thousands of clients. We continuously invest in 
                our fleet, training, and technology to ensure we deliver the highest standards 
                of service.
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#555' }}>
                Today, BARQ ALWUSOOL operates a modern fleet of vehicles ranging from compact 
                vans to luxury coaches, all maintained to the highest RTA standards. Our team 
                of professional drivers and support staff work tirelessly to ensure every 
                journey is safe, comfortable, and punctual.
              </p>
            </div>
          </div>
        </div>
      </section>

      <WhyChoose />
    </div>
  );
}

export default AboutPage;